export default __webpack_public_path__ + "static/media/app-download-logo.f01ca53b.png";